import React from 'react'
import {Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import SaveDialogBase from './SaveDialogBase';
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import {connect} from 'react-redux'


const style = theme => ({
    root: {},
    icon: {
        color: theme.palette.common.success,
    }
})

function SaveDialogInfo(
    {
        classes,
        onClose,
        message,

    }) {

    return (
        <SaveDialogBase
            onClose={onClose}
            Icon={CheckCircleIcon}
            iconClassName={classes.icon}
        >
            <Typography variant='body1'>
                {message}
            </Typography>
        </SaveDialogBase>
    )
}

SaveDialogInfo.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    message: state.store.saveStatusMessage
}), {})(withStyles(style)(SaveDialogInfo));